import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "#60BD3F",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m13.278 12 4.218-4.219a.701.701 0 1 0-.992-.992l-4.218 4.218L8.067 6.79a.701.701 0 1 0-.992.992L11.293 12l-4.218 4.218a.701.701 0 1 0 .992.993l4.219-4.219 4.218 4.219a.7.7 0 0 0 .992 0 .701.701 0 0 0 0-.993L13.278 12Z"
    }, null, -1)
  ]))]))
}
export default { render: render }